export default __webpack_public_path__ + "static/media/ic-practice.763dbfba.svg";